// 模組07 訊息功能 — 通知規則 mock 種子(9月交付 ticket 08/09)。
//
// 形狀出自 constants/notifyRules.js 的 buildNotifyRule(schema 單一來源)。
// 八條規則照 WF_v3「DCK-07-01-01_設定」列表畫面稿的樣本資料逐列轉錄
// (結構+文案對稿;display 是列表顯示用的文字,cadence 仍取確認單建議預設 ——
// 兩邊參數不一致一事已回報客戶,見 .scratch/9月交付/issues/09 Comments)。
// `active` 與暫停規則同慣例:只由審核引擎回寫,前端不自己切。
import { buildNotifyRule } from "../../constants/notifyRules";
import { NOTIFY_CATEGORY } from "../../constants/notifyCategories";

/** 把各階接收者填進工廠長出的 stages(種子只差這一件事) */
const withReceivers = (rule, byLevel) => ({
  ...rule,
  stages: rule.stages.map((s) => ({ ...s, receivers: byLevel[s.level] || [] })),
});

/** 稿上註記「現行僅定義至二階」的規則:三階停用(第 7 列) */
const disableStage3 = (rule) => ({
  ...rule,
  stages: rule.stages.map((s) => (s.level === 3 ? { ...s, enabled: false } : s)),
});

const CHANNEL = "站內・Email";

export const notifyRules = [
  withReceivers(
    buildNotifyRule({
      id: 1,
      category: NOTIFY_CATEGORY.UNFILLED,
      name: "資料未填提醒",
      monitor: [
        { module: "資產管理", fields: ["機房", "機櫃", "硬體", "軟體"] },
        { module: "營運資訊", fields: ["合約", "專案", "廠商", "IP"] },
      ],
      display: {
        trigger: ["資產・營運", "共 9 個納管欄位"],
        firstFreq: ["D＋15 天", "D＝填寫完成日期"],
        escalation: ["2階:＋15 天(固定)", "3階:＋30 天"],
      },
      channel: CHANNEL,
      createdBy: "王志明（總經理室）",
      createdAt: "2026-08-01T09:00:00+08:00",
    }),
    { 1: ["該筆資料之管理者"], 2: ["該筆資料之單位主管"], 3: ["跨單位管理主管"] }
  ),
  withReceivers(
    buildNotifyRule({
      id: 2,
      category: NOTIFY_CATEGORY.DUE,
      name: "合約／專案到期提醒",
      monitor: [{ module: "營運資訊", fields: ["合約到期", "專案到期"] }],
      display: {
        trigger: ["合約到期、專案到期", "合約維護排程"],
        firstFreq: ["前 300 天首次", "再次＝前 180 天"],
        escalation: ["2階:前 90 天", "3階:前 60 天"],
      },
      channel: CHANNEL,
      createdBy: "王志明（總經理室）",
      createdAt: "2026-08-01T09:05:00+08:00",
    }),
    { 1: ["合約承辦人"], 2: ["承辦單位主管"], 3: ["跨單位管理主管"] }
  ),
  withReceivers(
    buildNotifyRule({
      id: 3,
      category: NOTIFY_CATEGORY.DUE,
      name: "EOS／EOL／KEV 到期提醒",
      monitor: [{ module: "資產管理", fields: ["EOS", "EOL", "KEV 修補期限"] }],
      display: {
        trigger: ["EOS、EOL、KEV 修補期限", "硬體攤提到期"],
        firstFreq: ["嚴重≤30 天(含逾期)／高 31–90", "中 91–180／低 181–365"],
        escalation: ["依級距四時點發送", ">365 天不列風險"],
      },
      channel: CHANNEL,
      createdBy: "吳文凱（機房管理組）",
      createdAt: "2026-08-02T10:00:00+08:00",
    }),
    { 1: ["資產管理者＋資安窗口"], 2: ["單位主管"], 3: ["跨單位管理主管"] }
  ),
  withReceivers(
    buildNotifyRule({
      id: 4,
      category: NOTIFY_CATEGORY.STOCK,
      name: "機房／機櫃容量餘裕提醒",
      monitor: [{ module: "資產管理", fields: ["機櫃 U 位使用率", "PDU 使用率"] }],
      display: {
        trigger: ["機櫃 U 位使用率、PDU 使用率", "機櫃子單位台數上限 6 台"],
        firstFreq: ["事件觸發(異動當下檢查)", "無週期續發"],
        escalation: ["70%→一階", "80%→二階", "90%→三階"],
      },
      channel: CHANNEL,
      createdBy: "吳文凱（機房管理組）",
      createdAt: "2026-08-02T10:30:00+08:00",
    }),
    { 1: ["機櫃管理者"], 2: ["機房管理組主管"], 3: ["跨單位管理主管"] }
  ),
  withReceivers(
    buildNotifyRule({
      id: 5,
      category: NOTIFY_CATEGORY.APPROVAL,
      name: "審核待辦催辦",
      monitor: [{ module: "審核中心", fields: ["新增", "異動", "刪除", "暫停"] }],
      display: {
        trigger: ["新增、異動、刪除、暫停", "全模組"],
        firstFreq: ["每關停留 1 天", "最小 0.5 天;逾時持續催辦不作廢"],
        escalation: ["2階:逾 2 倍", "3階:逾 4 倍", "加倍遞增;無第三關止於二階"],
      },
      channel: CHANNEL,
      createdBy: "王志明（總經理室）",
      createdAt: "2026-08-03T11:00:00+08:00",
    }),
    { 1: ["目前關卡審核者"], 2: ["審核者之單位主管"], 3: ["跨單位管理主管"] }
  ),
  withReceivers(
    buildNotifyRule({
      id: 6,
      category: NOTIFY_CATEGORY.ALERT,
      name: "連線／系統告警",
      monitor: [{ module: "監控派工", fields: ["CPU", "RAM", "Disk", "VM 門檻"] }],
      display: {
        trigger: ["連線告警、系統告警", "CPU／RAM／Disk／VM 門檻 70,80,90%"],
        firstFreq: ["5 分/次,連 3 次第 3 次觸發", "之後每 15 分鐘"],
        escalation: ["2階:持續 30 分鐘未恢復", "現行僅定義至二階", "收件者僅標的物管理者"],
      },
      channel: CHANNEL,
      createdBy: "吳文凱（機房管理組）",
      createdAt: "2026-08-03T14:00:00+08:00",
    }),
    { 1: ["設備管理者"], 2: ["機房管理組主管"], 3: ["跨單位管理主管"] }
  ),
  disableStage3(withReceivers(
    buildNotifyRule({
      id: 7,
      category: NOTIFY_CATEGORY.ALERT,
      name: "硬體／應用系統告警",
      // 暫停中的示範(對稿:列表第 7 列狀態=暫停):核准後的停用
      active: false,
      monitor: [{ module: "監控派工", fields: ["硬體告警", "應用系統告警"] }],
      display: {
        trigger: ["硬體告警、應用系統告警", "介接客戶既有監控"],
        firstFreq: ["依原廠 Trap Critical"],
        escalation: ["--"],
      },
      channel: CHANNEL,
      createdBy: "吳文凱（機房管理組）",
      createdAt: "2026-08-04T09:00:00+08:00",
    }),
    { 1: ["設備管理者"], 2: ["機房管理組主管"] }
  )),
  withReceivers(
    buildNotifyRule({
      id: 8,
      category: NOTIFY_CATEGORY.VERSION,
      name: "軟硬體版本更新",
      monitor: [{ module: "軟體資訊", fields: ["軟體新版", "韌體新版", "未修補 CVE"] }],
      display: {
        trigger: ["軟體新版、韌體新版", "新增未修補 CVE"],
        firstFreq: ["每 30 天", "直到更新或標記略過"],
        escalation: ["升級時", "公告當下即通知"],
      },
      channel: CHANNEL,
      createdBy: "王志明（總經理室）",
      createdAt: "2026-08-04T15:00:00+08:00",
    }),
    { 1: ["軟體管理者"], 2: ["軟體管理單位主管"] }
  ),
];
